/**
 * Next section smooth scroll
 * Scrolls to the next sibling section when a .js-nextSection element is clicked.
 */

var nextSection = {
    init: function () {
        document.querySelectorAll('.js-nextSection').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var section = el.closest('section') || el.closest('[class*="block-"]');
                if ( ! section ) return;

                var next = section.nextElementSibling;
                if ( ! next ) return;

                // Mobile header is fixed — stop below it
                var header = document.querySelector('.site > header');
                var offset = header && getComputedStyle(header).position === 'fixed' ? header.offsetHeight : 0;

                var top = next.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({ top: top, behavior: 'smooth' });
            });
        });
    },
};

export { nextSection };
